var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _g, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIllustrationTeam(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 600,
    viewBox: "0 0 800 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M363.427 154.36C363.429 154.926 363.263 155.48 362.95 155.952C362.637 156.423 362.191 156.791 361.668 157.009C361.146 157.227 360.571 157.285 360.015 157.176C359.46 157.067 358.949 156.795 358.548 156.396C358.147 155.996 357.874 155.487 357.763 154.932C357.652 154.377 357.708 153.801 357.924 153.278C358.14 152.755 358.507 152.307 358.977 151.993C359.448 151.678 360.001 151.51 360.567 151.51C361.324 151.51 362.05 151.81 362.586 152.344C363.122 152.878 363.424 153.603 363.427 154.36Z",
    fill: "#DDDDDD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M376.68 154.36H432.2",
    stroke: "#EDEDED",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M363.427 167.59C363.427 168.156 363.259 168.709 362.945 169.179C362.631 169.649 362.184 170.016 361.662 170.232C361.139 170.449 360.564 170.505 360.009 170.395C359.454 170.285 358.945 170.012 358.545 169.612C358.145 169.212 357.872 168.703 357.762 168.148C357.652 167.593 357.708 167.018 357.925 166.496C358.141 165.973 358.508 165.526 358.978 165.212C359.448 164.898 360.001 164.73 360.567 164.73C360.943 164.729 361.315 164.802 361.663 164.945C362.011 165.088 362.326 165.299 362.592 165.565C362.858 165.831 363.069 166.146 363.212 166.494C363.355 166.842 363.428 167.214 363.427 167.59Z",
    fill: "#DDDDDD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M376.68 167.59H398.08",
    stroke: "#EDEDED",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M199.31 154.36C199.312 154.926 199.146 155.48 198.833 155.952C198.52 156.423 198.074 156.791 197.551 157.009C197.029 157.227 196.453 157.285 195.898 157.176C195.343 157.067 194.832 156.795 194.431 156.396C194.03 155.996 193.757 155.487 193.646 154.932C193.534 154.377 193.59 153.801 193.807 153.278C194.023 152.755 194.389 152.307 194.86 151.993C195.33 151.678 195.884 151.51 196.45 151.51C197.207 151.51 197.933 151.81 198.469 152.344C199.005 152.878 199.307 153.603 199.31 154.36Z",
    fill: "#DDDDDD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M212.57 154.36H286.54",
    stroke: "#EDEDED",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M196.45 170.45C198.029 170.45 199.31 169.17 199.31 167.59C199.31 166.01 198.029 164.73 196.45 164.73C194.87 164.73 193.59 166.01 193.59 167.59C193.59 169.17 194.87 170.45 196.45 170.45Z",
    fill: "#DDDDDD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M212.57 167.59H248.38",
    stroke: "#EDEDED",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M199.31 181.06C199.312 181.626 199.146 182.18 198.833 182.652C198.52 183.123 198.074 183.491 197.551 183.709C197.029 183.927 196.453 183.985 195.898 183.876C195.343 183.767 194.832 183.495 194.431 183.096C194.03 182.696 193.757 182.187 193.646 181.632C193.534 181.077 193.59 180.501 193.807 179.978C194.023 179.455 194.389 179.007 194.86 178.693C195.33 178.378 195.884 178.21 196.45 178.21C197.207 178.21 197.933 178.51 198.469 179.044C199.005 179.578 199.307 180.303 199.31 181.06Z",
    fill: "#DDDDDD"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M212.57 181.06H259.19",
    stroke: "#EDEDED",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M475.13 123.2H352.59V138.19H475.13V123.2Z",
    stroke: "#DDDDDD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M314.149 123.2H191.609V138.19H314.149V123.2Z",
    stroke: "#DDDDDD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M637.17 94.52H140V411.52H637.17V94.52Z",
    stroke: "#EDEDED",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M645.439 411.92H131.719V425.78H645.439V411.92Z",
    stroke: "#DDDDDD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M645.439 80.66H131.719V94.52H645.439V80.66Z",
    stroke: "#DDDDDD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M565.39 140.18C542.16 130.68 530.64 157.31 539.39 174.04C541.45 177.96 541.15 181.15 539.2 185.91C537.25 190.67 537.2 194.07 542.47 196.21C547.74 198.35 550.07 195.91 552.02 191.15C553.97 186.39 556.02 183.91 560.2 182.55C578.18 176.75 588.63 149.68 565.39 140.18Z",
    fill: "#F9F9F9",
    stroke: "#DDDDDD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M545.078 191.08C543.728 185.41 544.178 181.47 548.238 180.51C552.298 179.55 555.558 177.25 553.778 174.28C551.998 171.31 544.618 170.62 546.638 174.22C548.658 177.82 559.288 176.53 556.798 173.01C554.308 169.49 548.368 166.57 550.798 166.01C553.228 165.45 560.658 168.81 558.258 166.19C553.438 160.94 559.068 159.83 560.618 154.19",
    stroke: "#DDDDDD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M555 189.42C554.179 190.808 553.47 192.259 552.88 193.76C552.435 194.898 551.9 195.998 551.28 197.05C549.06 200.78 546.09 202.27 540.84 200.13C535.59 197.99 534.54 194.84 535.57 190.63C535.86 189.44 536.248 188.276 536.73 187.15C537.352 185.666 537.863 184.139 538.26 182.58C543.372 185.87 549.047 188.189 555 189.42Z",
    fill: "#F9F9F9",
    stroke: "#EDEDED",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M555 189.42C554.263 190.661 553.624 191.959 553.09 193.3C553.01 193.45 552.95 193.61 552.88 193.76C552.435 194.898 551.9 195.998 551.28 197.05C549.13 197.53 546.37 197.13 542.69 195.62C539.01 194.11 536.76 192.47 535.57 190.62C535.86 189.43 536.248 188.266 536.73 187.14L536.91 186.67C537.457 185.337 537.908 183.967 538.26 182.57C543.372 185.863 549.047 188.185 555 189.42Z",
    fill: "#F9F9F9",
    stroke: "#EDEDED",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M555 189.42C554.263 190.661 553.624 191.959 553.09 193.3C547.304 192.212 541.8 189.959 536.91 186.68C537.456 185.347 537.908 183.977 538.26 182.58C543.372 185.87 549.047 188.189 555 189.42Z",
    fill: "#F9F9F9",
    stroke: "#EDEDED",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M569.34 133.95L573.73 123.2",
    stroke: "#DDDDDD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M586.398 150.45L596.968 148.93",
    stroke: "#DDDDDD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M539.36 135.8L529.91 125.67",
    stroke: "#DDDDDD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M554.469 131.55V124.41",
    stroke: "#EDEDED",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M529.879 152.83L521.949 153.97",
    stroke: "#EDEDED",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M582.32 172.6L585.24 177.61",
    stroke: "#EDEDED",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M580.258 142.1L585.968 139.39",
    stroke: "#EDEDED",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M180.598 189.72H157.178C155.159 198.545 155.736 207.765 158.838 216.27L183.388 215.88C183.388 215.88 176.768 201.5 180.598 189.72Z",
    fill: "#DDDDDD",
    stroke: "#DDDDDD",
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M175.318 196.34H163.398",
    stroke: "#F9F9F9",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M174.557 201.51H165.547",
    stroke: "#F9F9F9",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M175.138 206.44H162.648",
    stroke: "#F9F9F9",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M162.797 150.6H185.337C187.097 158.51 185.69 166.795 181.417 173.68L157.027 172.68C157.027 172.68 164.467 162 162.797 150.6Z",
    stroke: "#DDDDDD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M166.918 155.99H181.638",
    stroke: "#DDDDDD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M167.129 160.93H178.879",
    stroke: "#DDDDDD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M166.918 167.39H172.468",
    stroke: "#DDDDDD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M173.73 167.39H177.42",
    stroke: "#DDDDDD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M218.327 224.56L240.877 224.61C242.646 232.512 241.254 240.792 236.997 247.68L212.617 246.68C212.617 246.68 219.997 235.94 218.327 224.56Z",
    stroke: "#EDEDED",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M222.449 229.96H237.169",
    stroke: "#EDEDED",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M222.66 234.89H234.41",
    stroke: "#EDEDED",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M222.449 241.35H227.999",
    stroke: "#EDEDED",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M229.258 241.35H232.948",
    stroke: "#EDEDED",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M406 236.12H428.54C430.298 244.027 428.891 252.307 424.62 259.19L400.23 258.19C400.23 258.19 407.66 247.5 406 236.12Z",
    stroke: "#EDEDED",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M410.109 241.52H424.829",
    stroke: "#EDEDED",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M410.32 246.45H422.07",
    stroke: "#EDEDED",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M410.109 252.91H415.659",
    stroke: "#EDEDED",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M416.918 252.91H420.608",
    stroke: "#EDEDED",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M481.997 148.47L459.457 148.52C457.7 156.427 459.107 164.707 463.377 171.59L487.767 170.59C487.767 170.59 480.347 159.85 481.997 148.47Z",
    stroke: "#DDDDDD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M477.9 153.87H463.18",
    stroke: "#DDDDDD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M477.689 158.8H465.949",
    stroke: "#DDDDDD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M477.898 165.26H472.348",
    stroke: "#DDDDDD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M471.088 165.26H467.398",
    stroke: "#DDDDDD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M333.988 120.44V356.45",
    stroke: "#EDEDED",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M451.69 179.9C446.22 163.7 443.81 157.9 440.69 154.39C437.57 150.88 428.74 147.15 428.74 147.15C428.74 147.15 425.06 132.89 420.35 133.35C415.64 133.81 423.45 152.78 423.45 152.78L419.31 171.4C420.653 173.585 421.698 175.939 422.42 178.4C425.64 188.98 434.47 189.98 436.9 198.86C436.75 198.35 451.64 189.43 451.69 179.9Z",
    fill: "#FEBD9D"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M451.69 179.9C446.22 163.7 443.81 157.9 440.69 154.39C437.57 150.88 428.74 147.15 428.74 147.15C428.74 147.15 425.06 132.89 420.35 133.35C415.64 133.81 423.45 152.78 423.45 152.78L419.31 171.4C420.653 173.585 421.698 175.939 422.42 178.4C425.64 188.98 434.47 189.98 436.9 198.86C436.75 198.35 451.64 189.43 451.69 179.9Z",
    fill: "#FEBD9D"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M440.702 154.39C437.602 150.82 428.752 147.15 428.752 147.15C428.752 147.15 425.072 132.89 420.362 133.35C415.652 133.81 423.462 152.78 423.462 152.78L419.322 171.4",
    stroke: "#EF8A66",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M414.641 164.11C418.531 161.03 425.201 172.31 421.171 175.39C418.281 177.6 410.941 167 414.641 164.11Z",
    fill: "#FEBD9D",
    stroke: "#EF8A66",
    strokeMiterlimit: 10
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M428.751 147.15C425.651 145.93 425.261 151.15 427.971 153.15C430.681 155.15 432.411 155.57 432.801 156.83C433.191 158.09 433.961 162.04 433.961 162.04C433.092 164.536 432.759 167.187 432.985 169.82C433.211 172.453 433.99 175.009 435.271 177.32",
    stroke: "#EF8A66",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M417.553 157.66C421.443 154.58 429.683 168.66 425.653 171.72C422.773 173.92 413.853 160.58 417.553 157.66Z",
    fill: "#FEBD9D",
    stroke: "#EF8A66",
    strokeMiterlimit: 10
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M420.931 153.1C424.821 150.02 433.071 164.1 429.041 167.16C426.161 169.36 417.241 156 420.931 153.1Z",
    fill: "#FEBD9D",
    stroke: "#EF8A66",
    strokeMiterlimit: 10
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M437.449 209.12L432.199 198.87C432.199 198.87 445.039 190.08 451.689 179.87L456.099 187.26C456.099 187.26 450.829 210.43 437.449 209.12Z",
    fill: "white"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M514.199 258.52C496.289 232.71 473.349 207.31 470.089 203.76C468.363 201.722 465.938 200.402 463.289 200.06L455.289 185.85C455.289 185.85 446.559 198.85 432.199 205.85L439.459 219.77C439.459 219.77 437.239 221.46 442.119 231.71C446.999 241.96 465.889 281.11 475.439 288.88C498.279 307.46 537.739 292.45 514.199 258.52Z",
    fill: "#A7CAF0"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M451.092 211.83L443.012 198.87",
    stroke: "#83ADDF",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M446.272 215.05L438.332 202.32",
    stroke: "#83ADDF",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M451.691 190.44L460.211 204.11",
    stroke: "#83ADDF",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M447.422 194.75L455.952 208.42",
    stroke: "#83ADDF",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M514.203 258.52C496.293 232.71 473.353 207.31 470.093 203.76C468.367 201.722 465.942 200.402 463.293 200.06L455.293 185.85",
    stroke: "#83ADDF",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M681.189 503.08H582.309V425.17L670.739 423.94C677.549 452.67 681.189 503.08 681.189 503.08Z",
    fill: "#683F1D"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M630.451 503.08C630.451 503.08 627.211 471.7 626.881 468.71C626.784 467.919 626.431 467.181 625.874 466.61C625.318 466.039 624.589 465.667 623.801 465.55C621.904 465.16 619.948 465.16 618.051 465.55",
    stroke: "#91613D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M688.31 313.83C686.73 339.92 681.31 380.48 677.56 406.32C675.45 420.87 673.9 430.76 673.9 430.76C673.9 430.76 610.63 433.22 593.44 432.76C576.25 432.3 574.37 431.03 574.37 424.1C574.37 417.17 574.66 330.63 574.66 330.63C574.66 330.63 489.78 300.63 477.56 290.44C465.34 280.25 479.97 246.76 511.39 253.63C519.29 255.36 527.14 257.12 535.16 258.89C559 264.18 584.29 269.5 616 274C650.44 278.92 672 279.2 686.72 288.88C688.9 290.31 689.15 300.06 688.31 313.83Z",
    fill: "#A7CAF0"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M665.461 340.06C652.091 348.54 652.061 360.47 657.291 369.71C669.351 390.98 634.291 377.16 632.781 403.54L683.541 391.48L665.461 340.06Z",
    fill: "#93BEE5"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M706.87 322C701.072 318.478 694.83 315.744 688.31 313.87C677.52 310.87 667.11 311.5 660.2 318.62C658.965 319.889 657.887 321.303 656.99 322.83C639.68 351.83 591.28 346.54 582.31 315.96C574.68 289.96 562.91 273.8 535.16 258.96C559 264.18 584.29 269.5 616 274C650.44 278.92 672 279.2 686.72 288.88C693.54 291.76 700.65 304.94 706.87 322Z",
    fill: "#C3DCF8"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M619.231 272.11C607.951 272.11 598.801 279.32 598.801 288.2C598.801 293.2 601.701 297.68 606.261 300.63C608.467 302.051 610.908 303.067 613.471 303.63C615.359 304.068 617.292 304.286 619.231 304.28C619.661 304.28 620.081 304.28 620.501 304.28C623.22 304.162 625.9 303.59 628.431 302.59C630.827 301.678 633.029 300.321 634.921 298.59C636.385 297.291 637.564 295.702 638.384 293.924C639.203 292.146 639.645 290.217 639.681 288.26C639.681 279.32 630.531 272.11 619.231 272.11ZM626.001 296C624.004 296.617 621.931 296.954 619.841 297H619.231C617.594 297.006 615.962 296.839 614.361 296.5C612.302 296.098 610.327 295.347 608.521 294.28C605.621 292.53 603.821 290.07 603.821 287.35C603.821 282.01 610.721 277.69 619.231 277.69C627.741 277.69 634.651 282.01 634.651 287.35C634.651 289.7 633.311 291.85 631.071 293.53C629.538 294.643 627.822 295.479 626.001 296Z",
    stroke: "#83ADDF",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M609.069 268C605.249 268.73 600.999 270 598.869 273.66C596.739 277.32 596.639 292.57 598.589 294.24C600.539 295.91 603.139 287.93 614.769 284.04L609.069 268Z",
    fill: "white"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M624.551 284.76L636.421 266C636.421 266 642.721 269.34 643.741 275.37C644.761 281.4 642.001 301.17 637.001 296.16C633.451 292.66 634.251 289.77 624.551 284.76Z",
    fill: "white"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M606.258 300.63L608.518 294.25",
    stroke: "#83ADDF",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M613.469 303.64L614.359 296.47",
    stroke: "#83ADDF",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M620.5 304.26L619.84 296.96",
    stroke: "#83ADDF",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M628.43 302.57L626 295.98",
    stroke: "#83ADDF",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M634.92 298.53L631.07 293.5",
    stroke: "#83ADDF",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M638.221 268.54C638.311 270.88 633.542 286.26 620.302 287.54C607.062 288.82 605.122 274.4 605.202 270.61C605.202 269.08 605.372 266.38 605.562 263C605.822 258.36 606.172 252.45 606.432 246.59L606.492 245.31C607.952 211.31 637.142 218.1 635.322 236.12C634.212 247.23 638.111 266.21 638.221 268.54Z",
    fill: "#FEBD9D"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M605.559 263C605.819 258.36 606.169 252.45 606.429 246.59L622.599 244.09C623.189 254.4 618.209 263.27 605.559 263Z",
    fill: "#F4A789"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M670.999 388.76C670.999 388.56 670.889 388.36 670.839 388.15C666.309 369.94 662.549 350.89 660.969 334.26",
    stroke: "#83ADDF",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M597 365.9C595.54 359.56 599.36 357.7 602.69 356.56C602.38 354.77 603.04 351.87 607.01 351.25C610.77 350.66 612.12 354.36 612.12 354.36C612.12 354.36 620.03 351.68 622.03 359.73L597 365.9Z",
    fill: "#DDDDDD"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M577.789 367.67L637.539 353.86L660.199 449.87L599.929 462L577.789 367.67Z",
    fill: "#F9F9F9",
    stroke: "#DDDDDD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M605 356.12C604.998 356.652 605.154 357.174 605.449 357.617C605.743 358.061 606.162 358.407 606.654 358.612C607.145 358.817 607.686 358.872 608.209 358.77C608.731 358.667 609.211 358.411 609.589 358.036C609.966 357.66 610.223 357.181 610.328 356.658C610.432 356.136 610.38 355.595 610.176 355.103C609.973 354.611 609.628 354.19 609.186 353.894C608.743 353.598 608.222 353.44 607.69 353.44C606.978 353.44 606.296 353.722 605.791 354.224C605.287 354.727 605.003 355.408 605 356.12Z",
    fill: "#F9F9F9",
    stroke: "#DDDDDD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M725 408.33C725.019 410.233 724.933 412.136 724.74 414.03V414.31C724.678 414.695 724.591 415.076 724.48 415.45C722.04 423.45 706.6 431 692.26 422.7C691.003 421.971 689.8 421.152 688.66 420.25C684.015 416.415 680.23 411.645 677.55 406.25C674.695 400.694 672.497 394.825 671 388.76C671 388.56 670.89 388.36 670.84 388.15C664.84 363.87 660.12 338.09 660.16 318.58C660.16 295.06 667.09 280.64 686.72 288.9C693.5 291.76 700.61 304.9 706.83 321.96C712.094 336.743 716.341 351.868 719.54 367.23C723 383.2 725 398.18 725 408.33Z",
    fill: "#A7CAF0"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M724.779 414.06V414.34C724.716 414.725 724.63 415.106 724.519 415.48C722.079 423.48 706.639 431.03 692.299 422.73C691.042 422.001 689.839 421.182 688.699 420.28C693.073 418.022 697.994 417.041 702.899 417.45C729.289 419.83 701.289 390.68 719.609 367.23C722.979 383.23 725.039 398.18 725.069 408.33C725.195 410.245 725.098 412.168 724.779 414.06Z",
    fill: "#93BEE5"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M706.869 322C701.071 318.478 694.829 315.744 688.309 313.87C677.519 310.87 667.109 311.5 660.199 318.62C660.199 295.1 667.129 280.68 686.759 288.94C693.539 291.76 700.649 304.94 706.869 322Z",
    fill: "#C3DCF8"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M607.069 408.76C605.439 407.76 595.789 402.18 592.989 402C590.189 401.82 584.219 405.95 584.219 405.95C584.219 405.95 572.369 406.65 571.059 408.76C569.749 410.87 572.409 413.84 574.449 414.9C576.489 415.96 574.569 418.14 574.829 419.9C575.089 421.66 577.289 422.9 577.549 424.11C577.809 425.32 576.669 428.62 579.389 429.43C582.109 430.24 580.389 431.91 581.759 434.28C583.129 436.65 591.499 436.21 612.759 432L607.069 408.76Z",
    fill: "#FEBD9D"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M593.001 402C590.191 401.83 584.231 405.95 584.231 405.95C584.231 405.95 572.381 406.65 571.071 408.76C569.761 410.87 572.421 413.84 574.461 414.9C576.501 415.96 574.581 418.14 574.841 419.9C575.101 421.66 577.301 422.9 577.561 424.11C577.821 425.32 576.681 428.62 579.401 429.43C582.121 430.24 580.401 431.91 581.771 434.28C582.321 435.21 583.951 435.71 587.011 435.71",
    stroke: "#EF8A66",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M605.578 406.84L609.848 434.16L618.858 432.83L616.058 406.17L605.578 406.84Z",
    fill: "white"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M724.751 414.34C724.671 414.72 724.591 415.11 724.491 415.48C722.111 424.85 712.071 430.91 684.551 432.83C682.151 433.003 679.774 433.157 677.421 433.29C644.781 435.23 616.551 434.67 616.551 434.67L612.301 405.48C627.101 401.09 651.691 392.77 671.041 388.76C679.041 387.11 686.091 386.18 691.241 386.56C697.107 386.878 702.921 387.834 708.581 389.41C710.087 389.844 711.563 390.375 713.001 391C719.621 394 724.071 398.72 724.911 406.42C724.981 407.06 725.031 407.7 725.081 408.31C725.211 410.326 725.1 412.35 724.751 414.34Z",
    fill: "#A7CAF0"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M691.241 386.56C686.091 386.18 679.011 387.11 671.041 388.76C651.691 392.76 627.101 401.09 612.301 405.48L616.551 434.67",
    stroke: "#83ADDF",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M612.809 408.94L630.129 406.17",
    stroke: "#83ADDF",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M613.629 414.55L630.459 412.45",
    stroke: "#83ADDF",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M614.25 418.86L630.87 417.45",
    stroke: "#83ADDF",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M615.168 425.18L631.208 423.94",
    stroke: "#83ADDF",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M616.059 430.33L631.789 428.75",
    stroke: "#83ADDF",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M584.219 406C588.509 405.56 592.369 405.38 592.369 405.38",
    stroke: "#EF8A66",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M724.748 414.34C724.685 414.725 724.598 415.106 724.488 415.48C722.108 424.85 712.068 430.91 684.548 432.83C682.148 433.003 679.771 433.157 677.418 433.29C683.538 418.15 697.128 416.93 702.868 417.45C720.538 419.05 713.868 406.52 712.958 391.02C719.578 394.02 724.028 398.74 724.868 406.44C724.938 407.08 724.988 407.72 725.038 408.33C725.18 410.338 725.082 412.355 724.748 414.34Z",
    fill: "#93BEE5"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M633.41 213.56C632.754 218.41 631.584 223.177 629.92 227.78C627.33 234.52 623.14 240.41 616.31 240.36C615.589 240.351 614.87 240.284 614.16 240.16L596 232.71C596 232.71 596.08 232.36 596.26 231.71C597.536 227.296 599.403 223.074 601.81 219.16C602.02 218.83 602.25 218.5 602.47 218.16C606.79 211.61 611.11 206.37 611.11 206.37C611.11 206.37 611.36 200.1 616.48 199.18C621.6 198.26 634.83 204 633.41 213.56Z",
    fill: "#FEBD9D"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M629.921 227.78C627.331 234.52 623.141 240.41 616.311 240.36C615.076 239.572 614.039 238.51 613.278 237.258C612.518 236.006 612.055 234.596 611.925 233.136C611.794 231.677 612.001 230.207 612.528 228.84C613.055 227.473 613.888 226.245 614.964 225.251C616.04 224.256 617.33 223.522 618.734 223.104C620.138 222.686 621.62 222.595 623.064 222.84C624.509 223.084 625.878 223.656 627.067 224.513C628.255 225.369 629.232 226.487 629.921 227.78Z",
    fill: "#F4AF90"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M603.139 223.63C603.139 225.574 602.451 227.455 601.197 228.941C599.944 230.427 598.205 231.422 596.289 231.75C597.565 227.336 599.432 223.114 601.839 219.2C602.69 220.521 603.141 222.059 603.139 223.63Z",
    fill: "#F4AF90"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M645.15 214.85C644.33 217.19 641.54 224.4 640 228.37C639.37 229.98 638.94 231.06 638.94 231.06L634.52 229.45L631.35 228.3L630.23 227.9C630.23 227.9 630.23 228.37 630.11 229.19C629.79 232.235 629.205 235.247 628.36 238.19C627.359 241.853 625.724 245.312 623.53 248.41C617.53 256.41 601.95 255.59 594.76 249.41C589.76 245.07 590.76 237.13 595.11 228.87C597.172 225.055 599.65 221.48 602.5 218.21C602.5 218.21 598.99 226.44 598.42 228.21C597.73 230.42 600.32 230.21 601.32 228.33C602.32 226.45 604.25 225.15 609.85 226.65C615.45 228.15 617.73 231.05 616.69 235.1C616.08 237.49 620.52 238.32 623.79 235.17C624.07 234.902 624.33 234.615 624.57 234.31C625.019 233.755 625.404 233.151 625.72 232.51C628.72 226.4 630.47 217.05 630.64 213.37C627.29 213.58 624.4 211.03 626.3 207.86C622.37 209.51 619.45 206.69 620.12 202.93C618.42 205.6 614.6 205.43 614.12 202.27L611.12 206.37C610.542 204.817 610.27 203.166 610.32 201.51C610.54 196.51 614.79 194.69 618.15 195.84C618.67 192.23 627.15 191.51 627.77 196.67C629.59 193.31 635.62 194 635.77 199.19C636.553 198.764 637.453 198.6 638.337 198.722C639.22 198.844 640.042 199.246 640.681 199.868C641.32 200.491 641.743 201.301 641.889 202.181C642.034 203.061 641.894 203.965 641.49 204.76C644.24 204.16 646 207.76 643.63 210.34C643.66 210.39 646.32 211.56 645.15 214.85Z",
    fill: "#BF8228"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M616 219C616 219.265 616.079 219.524 616.226 219.744C616.373 219.965 616.582 220.137 616.827 220.238C617.072 220.339 617.342 220.366 617.601 220.314C617.861 220.263 618.1 220.135 618.288 219.948C618.475 219.76 618.603 219.521 618.654 219.261C618.706 219.001 618.679 218.732 618.578 218.487C618.477 218.242 618.305 218.033 618.084 217.886C617.864 217.739 617.605 217.66 617.34 217.66C616.985 217.66 616.644 217.801 616.392 218.052C616.141 218.304 616 218.645 616 219Z",
    fill: "#683F1D"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M607.43 216.13C607.428 216.396 607.505 216.656 607.651 216.878C607.798 217.1 608.007 217.273 608.252 217.376C608.498 217.479 608.768 217.506 609.029 217.455C609.29 217.403 609.529 217.275 609.717 217.087C609.905 216.899 610.033 216.66 610.084 216.399C610.136 216.138 610.108 215.868 610.006 215.623C609.903 215.377 609.73 215.168 609.508 215.022C609.286 214.875 609.026 214.798 608.76 214.8C608.408 214.803 608.071 214.944 607.822 215.192C607.573 215.441 607.432 215.778 607.43 216.13Z",
    fill: "#683F1D"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M618.7 211.94C618.01 214.33 625.02 216.69 625.32 215.23C625.54 214.18 619.72 208.4 618.7 211.94Z",
    fill: "#BF8228"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M608.759 208.77C608.349 210.05 614.239 212.26 614.929 210.11C615.749 207.55 609.119 207.67 608.759 208.77Z",
    fill: "#BF8228"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M634.518 229.45L630.228 227.9C629.959 231.395 629.333 234.853 628.358 238.22C626.968 238.43 625.358 237.7 623.788 235.22C624.581 234.452 625.234 233.552 625.718 232.56C628.718 226.45 630.468 217.1 630.638 213.42C627.288 213.63 624.398 211.08 626.298 207.91C622.368 209.56 619.448 206.74 620.118 202.98C618.418 205.65 614.598 205.48 614.118 202.32L611.118 206.42C610.54 204.867 610.269 203.216 610.318 201.56C611.938 199.91 614.158 198.77 616.018 199.34C616.018 199.34 620.908 200.52 622.628 198.18C621.678 201.94 625.518 205.52 630.048 203.98C630.048 203.98 631.628 210.81 637.158 210.8C637.158 210.8 636.558 216.91 639.718 217.47C642.108 217.88 637.278 224.77 634.518 229.45Z",
    fill: "#B57724"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M630.11 229.19C629.79 232.235 629.205 235.247 628.36 238.19C627.359 241.853 625.724 245.312 623.53 248.41C617.53 256.41 601.95 255.59 594.76 249.41C589.76 245.07 590.76 237.13 595.11 228.87C595.73 243.16 609.31 251.35 623.79 235.22L624.57 234.36C626.268 232.485 628.121 230.755 630.11 229.19Z",
    fill: "#B57724"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M639.998 228.37C639.368 229.98 638.938 231.06 638.938 231.06L634.518 229.45L631.348 228.3C636.248 225.05 638.738 226.45 639.998 228.37Z",
    fill: "#B57724"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M628.539 237.55C629.411 234.395 629.977 231.163 630.229 227.9C632.989 225.4 637.829 225.48 640.039 228.26C640.645 229.032 641.029 229.956 641.149 230.93C641.999 237 636.929 243.39 628.539 237.55Z",
    fill: "#FEBD9D"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M634.889 239.85C632.582 239.775 630.359 238.97 628.539 237.55",
    stroke: "#EF8A66",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M605.191 222.19C605.631 219.65 607.041 219.65 609.701 219.19C612.361 218.73 614.421 216.36 614.131 213.96",
    stroke: "#EF8A66",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M632.051 232C632.481 231.523 633.017 231.154 633.617 230.924C634.217 230.694 634.863 230.609 635.502 230.676C636.141 230.743 636.754 230.961 637.293 231.311C637.832 231.661 638.28 232.134 638.601 232.69",
    stroke: "#EF8A66",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M633.321 231.1C637.861 230.67 637.171 237.49 632.781 236.23",
    stroke: "#EF8A66",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M592.371 246.22C596.651 243.35 602.371 244.8 606.981 248.92C613.111 254.4 623.131 248.92 623.131 248.92",
    stroke: "#9B621F",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M627.668 240.36C625.168 242.36 615.668 247.87 608.828 242.78C601.988 237.69 591.668 244.07 591.668 244.07",
    stroke: "#9B621F",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M591.859 237.34C594.069 235.34 602.119 231.07 607.359 236.77C612.599 242.47 619.429 237.26 619.429 237.26",
    stroke: "#9B621F",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M601 228.87C602.27 230.26 611.35 233.45 616.63 231.52",
    stroke: "#9B621F",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M614.098 202.32C613.538 199.45 616.098 196.08 618.168 195.89",
    stroke: "#9B621F",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M620.121 203C620.531 200.72 623.251 195.25 627.121 195",
    stroke: "#9B621F",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M626.301 207.91C627.301 203.47 630.231 198.69 634.891 196.72",
    stroke: "#9B621F",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M630.641 213.42C631.261 208.57 637.971 204.56 641.521 204.81",
    stroke: "#9B621F",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M629.578 220.56C633.928 216.82 641.468 213.51 645.448 213.24",
    stroke: "#9B621F",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M605.69 230.1C609.62 230.95 614.02 230.49 613.88 230.67C613.74 230.85 613.06 236.67 608.76 236.06C604.46 235.45 605.69 230.1 605.69 230.1Z",
    fill: "white",
    stroke: "#EF8A66",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M493.141 248.93C495.841 241.4 499.401 233.76 501.061 234.77C503.871 236.48 498.301 251.12 498.301 251.12L493.141 248.93Z",
    fill: "#B25E47",
    stroke: "#934735",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M489.66 250.65C489.66 250.18 491.32 228.65 494.46 229.14C498.72 229.78 495.33 251.14 495.33 251.14L489.66 250.65Z",
    fill: "#B25E47",
    stroke: "#934735",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M484.522 253.69C484.402 232.12 484.822 226.57 487.442 226.56C491.062 226.56 491.532 251.41 491.532 251.41L484.522 253.69Z",
    fill: "#B25E47",
    stroke: "#934735",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M496.612 252.38C495.982 262.57 495.682 267.98 495.682 267.98C495.682 267.98 486.562 272.98 485.972 260.74C485.382 248.5 496.612 252.38 496.612 252.38Z",
    fill: "#B25E47",
    stroke: "#934735",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M444.472 315.77C432.422 333.64 417.702 358.48 429.592 366.45C441.482 374.42 457.322 371.17 466.792 349.25C476.262 327.33 487.942 289.17 490.282 285.41C492.622 281.65 498.062 277.23 501.572 269.97C505.082 262.71 506.762 262.31 505.572 260.24C504.382 258.17 501.422 258.94 499.862 261.24C498.302 263.54 494.152 267.99 491.812 266.69C489.472 265.39 488.482 262.77 488.442 259.56C488.402 256.35 490.312 252.9 493.982 254.02C497.652 255.14 499.342 259.95 502.452 258.26C505.562 256.57 498.952 250.09 496.612 248.01C494.272 245.93 492.462 247.36 488.612 248.66C484.762 249.96 483.552 250.09 481.612 254.66C479.672 259.23 472.272 274.19 471.102 276.91C469.932 279.63 455.762 299 444.472 315.77Z",
    fill: "#B25E47"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M501.573 270C505.073 262.73 506.763 262.34 505.573 260.27C504.383 258.2 501.423 258.97 499.863 261.27C498.303 263.57 494.153 268.02 491.813 266.72C489.473 265.42 488.483 262.8 488.443 259.59C488.403 256.38 490.313 252.93 493.983 254.05C497.653 255.17 499.343 259.98 502.453 258.29C505.563 256.6 498.953 250.12 496.613 248.04C494.273 245.96 492.463 247.39 488.613 248.69C484.763 249.99 483.553 250.12 481.613 254.69",
    stroke: "#934735",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M441.491 320.26C439.421 323.44 437.341 326.76 435.391 330.11",
    stroke: "#934735",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M259.41 332.76C256.11 337.89 262.91 341.76 269.05 345.76C275.19 349.76 276.8 331.56 276.8 331.56C276.8 331.56 261.23 329.93 259.41 332.76Z",
    fill: "#F7AD2B"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M443.1 310.53C445.18 312.09 442.1 317.28 436.19 323.05L431.34 316.79C431.34 316.79 438.25 308.74 443.1 310.53Z",
    fill: "#F7AD2B"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M433.299 312.09C447.139 326.74 463.199 346.02 454.669 360.66C446.139 375.3 425.779 367.53 413.459 356.3C413.459 356.3 403.429 337 433.299 312.09Z",
    fill: "#B25E47"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M268.93 332.35C263.61 344.16 248.22 370.54 264.53 381.42C280.84 392.3 300.68 354.13 300.68 354.13C300.68 354.13 294.62 331.31 268.93 332.35Z",
    fill: "#B25E47"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M443.1 310.53C431.938 318.797 423.192 329.901 417.77 342.69C415.827 347.05 414.381 351.616 413.46 356.3C410.26 353.98 402.7 348.3 402.7 348.3C402.14 351.83 401.41 355.89 400.7 359.99C398.51 371.76 395.99 383.76 395.99 383.76H321.18L319.92 378.76L310.14 340L300.68 354.11C300.49 353.88 300.3 353.66 300.09 353.45C289.09 341.56 259.41 332.74 259.41 332.74C267.474 319.136 277.099 306.521 288.09 295.15C291.308 291.865 294.689 288.745 298.22 285.8C303.165 281.882 308.589 278.609 314.36 276.06C320.922 273.079 327.723 270.654 334.69 268.81C334.69 268.81 334.85 252.89 336.59 234.07C337.36 225.58 354.59 223.92 358.59 238.36C362.59 252.8 365.59 262.08 365.59 262.08C369.892 261.445 374.245 261.214 378.59 261.39C384.1 261.61 390.37 262.62 395.28 265.45C397.92 266.98 403.19 271.55 409.28 277.22C423.83 290.75 443.1 310.53 443.1 310.53Z",
    fill: "#FED81D"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M417.769 342.69C415.825 347.05 414.38 351.616 413.459 356.3C410.259 353.98 402.699 348.3 402.699 348.3C404.937 337.342 406.043 326.184 405.999 315C405.972 310.076 404.794 305.227 402.559 300.84C409.499 304.75 415.259 309.01 411.889 318.29C408.699 326.89 409.189 341.25 417.769 342.69Z",
    fill: "#FCC71F"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M345.201 381.72L319.921 378.72L310.141 340C312.829 335.589 315.169 330.975 317.141 326.2C327.241 338.2 305.961 352.2 339.071 359.5C355.591 363.16 345.201 381.72 345.201 381.72Z",
    fill: "#FCC71F"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M409.31 277.24C400.54 278.04 392.02 284.72 386.67 302.57C377.03 334.74 341.79 330.96 329.67 308.7C320.18 291.26 308.49 289.3 288.07 295.17C291.288 291.885 294.669 288.765 298.2 285.82C303.146 281.902 308.569 278.629 314.34 276.08C320.902 273.099 327.703 270.674 334.67 268.83C334.67 268.83 334.83 252.91 336.57 234.09C337.34 225.6 354.57 223.94 358.57 238.38C362.57 252.82 365.57 262.1 365.57 262.1C369.873 261.465 374.225 261.234 378.57 261.41C384.08 261.63 390.35 262.64 395.26 265.47C397.94 267 403.21 271.57 409.31 277.24Z",
    fill: "#FFE05C"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M378.609 261.41C378.769 272.2 369.419 279.41 358.689 281.1C347.959 282.79 330.159 281.53 314.359 276.1C320.921 273.119 327.722 270.694 334.689 268.85C334.689 268.85 334.849 252.93 336.589 234.11C337.359 225.62 354.589 223.96 358.589 238.4C359.499 241.65 360.359 244.64 361.129 247.32C362.779 252.97 364.069 257.26 364.829 259.72C365.309 261.28 365.579 262.12 365.579 262.12C369.891 261.476 374.253 261.238 378.609 261.41Z",
    fill: "#B25E47"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M364.849 259.7C355.369 260.46 349.849 254.84 349.919 247.33C349.919 247.33 356.559 247.33 361.149 247.33C362.799 253 364.089 257.24 364.849 259.7Z",
    fill: "#914839"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M404.409 503.08H301.999C301.999 503.08 297.849 452.22 304.079 425.17C306.597 414.301 309.94 403.64 314.079 393.28C315.883 388.638 317.919 384.089 320.179 379.65L395.999 383.77C396.759 386.83 397.449 390.01 398.089 393.28C406.999 439.34 404.409 503.08 404.409 503.08Z",
    fill: "#A7CAF0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7823_13031",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 300,
    y: 379,
    width: 105,
    height: 125
  }, _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M404.409 503.08H301.999C301.999 503.08 297.849 452.22 304.079 425.17C306.597 414.301 309.94 403.64 314.079 393.28C315.883 388.638 317.919 384.089 320.179 379.65L395.999 383.77C396.759 386.83 397.449 390.01 398.089 393.28C406.999 439.34 404.409 503.08 404.409 503.08Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7823_13031)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M326.777 439.916C330.325 436.043 330.061 430.027 326.188 426.479C322.315 422.932 316.299 423.195 312.752 427.068C309.204 430.941 309.468 436.957 313.341 440.505C317.214 444.052 323.229 443.789 326.777 439.916Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.006 504.735C339.72 501.021 339.72 494.999 336.006 491.286C332.292 487.572 326.271 487.572 322.557 491.286C318.843 494.999 318.843 501.021 322.557 504.735C326.271 508.449 332.292 508.449 336.006 504.735Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.225 442.019C378.938 438.305 378.938 432.284 375.225 428.57C371.511 424.856 365.489 424.856 361.775 428.57C358.061 432.284 358.061 438.305 361.775 442.019C365.489 445.733 371.511 445.733 375.225 442.019Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.63 510.005C383.743 508.802 386.913 503.683 385.711 498.57C384.509 493.458 379.39 490.287 374.277 491.489C369.164 492.691 365.994 497.811 367.196 502.923C368.398 508.036 373.517 511.207 378.63 510.005Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.7 407.089C370.811 405.877 373.971 400.751 372.76 395.641C371.548 390.53 366.423 387.37 361.312 388.582C356.201 389.794 353.041 394.919 354.253 400.029C355.465 405.14 360.59 408.3 365.7 407.089Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.89 471.87C353.093 471.87 355.69 469.273 355.69 466.07C355.69 462.867 353.093 460.27 349.89 460.27C346.687 460.27 344.09 462.867 344.09 466.07C344.09 469.273 346.687 471.87 349.89 471.87Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.839 457.3C407.042 457.3 409.639 454.703 409.639 451.5C409.639 448.297 407.042 445.7 403.839 445.7C400.636 445.7 398.039 448.297 398.039 451.5C398.039 454.703 400.636 457.3 403.839 457.3Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.299 410.52C405.299 411.667 404.959 412.789 404.322 413.742C403.684 414.696 402.779 415.44 401.719 415.879C400.659 416.318 399.493 416.432 398.368 416.209C397.243 415.985 396.209 415.432 395.398 414.621C394.587 413.81 394.034 412.777 393.811 411.652C393.587 410.526 393.702 409.36 394.141 408.3C394.58 407.241 395.323 406.335 396.277 405.697C397.231 405.06 398.352 404.72 399.499 404.72C401.037 404.72 402.513 405.331 403.6 406.419C404.688 407.507 405.299 408.982 405.299 410.52Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.998 469.11C308.998 470.257 308.658 471.379 308.021 472.332C307.384 473.286 306.478 474.03 305.418 474.469C304.358 474.908 303.192 475.022 302.067 474.799C300.942 474.575 299.908 474.022 299.097 473.211C298.286 472.4 297.734 471.367 297.51 470.242C297.286 469.116 297.401 467.95 297.84 466.89C298.279 465.831 299.022 464.925 299.976 464.287C300.93 463.65 302.051 463.31 303.198 463.31C304.736 463.313 306.21 463.925 307.297 465.012C308.384 466.099 308.996 467.573 308.998 469.11Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.277 410.52C332.48 410.52 335.077 407.923 335.077 404.72C335.077 401.517 332.48 398.92 329.277 398.92C326.073 398.92 323.477 401.517 323.477 404.72C323.477 407.923 326.073 410.52 329.277 410.52Z",
    stroke: "white",
    strokeMiterlimit: 10
  }))), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M333 269.27C333 269.27 345.52 290.89 360.78 300.14C360.78 300.14 369.26 287.74 367.87 261.8",
    stroke: "#683F1D",
    strokeMiterlimit: 10
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M356.641 300.8C356.641 301.668 356.898 302.517 357.38 303.239C357.863 303.961 358.548 304.524 359.351 304.856C360.153 305.188 361.035 305.275 361.887 305.106C362.739 304.936 363.521 304.518 364.135 303.904C364.749 303.29 365.167 302.508 365.336 301.656C365.506 300.805 365.419 299.922 365.086 299.12C364.754 298.318 364.192 297.632 363.47 297.15C362.748 296.667 361.899 296.41 361.031 296.41C359.866 296.41 358.75 296.873 357.926 297.696C357.103 298.519 356.641 299.636 356.641 300.8Z",
    fill: "white"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M402.7 348.31C404.939 337.349 406.045 326.187 406 315C405.973 310.076 404.795 305.227 402.56 300.84C400.7 296.84 398.69 293.17 398.27 288.24",
    stroke: "#F7AD2B",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M318.418 323.13C318.418 323.13 317.948 324.35 317.148 326.22C315.177 330.995 312.837 335.609 310.148 340.02",
    stroke: "#F7AD2B",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M398 393.28H314C315.805 388.638 317.84 384.089 320.1 379.65L396 383.77C396.71 386.83 397.4 390 398 393.28Z",
    fill: "#83ADDF"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M364.629 393.28V416.15",
    stroke: "#83ADDF",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M366.391 417.69C368.771 416.38 370.141 415.76 370.391 414.32C370.641 412.88 371.831 397 371.831 397",
    stroke: "#83ADDF",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M363.5 503.08C363.5 503.08 364.1 439.31 364.6 436.41C364.597 436.38 364.597 436.35 364.6 436.32C365.11 435.37 366.14 433.96 371.8 430.65",
    stroke: "#83ADDF",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M239.5 271.85C244.56 269.91 250.07 270.3 257.11 273.66C265.35 277.6 272.49 287.73 269.01 301.66C268.44 303.91 259.68 308.59 258.23 307.56C256.78 306.53 268.26 278 239.5 271.85Z",
    fill: "white"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M330.35 234.38C325.87 233.95 323.05 235.79 320.96 239.6C318.87 243.41 316.23 247.21 316.23 247.21C316.23 247.21 321.67 249.43 326.98 243.4C331.92 237.78 330.35 234.38 330.35 234.38Z",
    fill: "#FED81D"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M333.619 236.12C328.559 237.47 326.189 239.51 325.279 245.64C324.369 251.77 324.689 254.58 324.039 256.89C324.039 256.89 330.519 255.39 333.619 249.57C336.569 244 335.819 240.43 333.619 236.12Z",
    fill: "#FED81D"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M340.001 203.4C340.001 203.4 335.121 214 335.001 222.89C334.925 224.901 335.224 226.908 335.881 228.81L330.471 229.44C325.841 233.89 317.471 232.36 320.471 226.68C315.471 229.8 308.921 225.53 312.171 221.02C308.281 221.94 306.301 215.65 311.311 214.02C307.141 213.57 306.311 206.13 311.961 205.7C311.468 205.189 311.13 204.548 310.985 203.853C310.84 203.157 310.895 202.435 311.142 201.77C311.39 201.104 311.821 200.522 312.385 200.09C312.949 199.658 313.624 199.395 314.331 199.33C314.92 199.313 315.505 199.43 316.043 199.672C316.58 199.915 317.054 200.277 317.431 200.73C315.011 192.01 325.241 189.23 328.381 193.81C328.931 190.12 335.851 189.74 336.881 194.5C342.101 191.62 345.501 198.62 340.001 203.4Z",
    fill: "#604730"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M335.92 228.81L330.51 229.44C325.88 233.89 317.51 232.36 320.51 226.68C315.51 229.8 308.96 225.53 312.21 221.02C308.32 221.94 306.34 215.65 311.35 214.02C307.18 213.57 306.35 206.13 312 205.7C311.507 205.188 311.169 204.548 311.024 203.853C310.879 203.157 310.934 202.435 311.181 201.77C311.429 201.104 311.86 200.522 312.424 200.09C312.988 199.658 313.663 199.395 314.37 199.33C314.01 202.41 315.37 206.77 318.37 207.07C314.27 208.58 314.3 213.44 318.37 215.15C315.82 217.98 319.64 221.96 322.83 219.72C322.71 222.84 327.4 227.92 334.98 222.84C334.918 224.871 335.236 226.896 335.92 228.81Z",
    fill: "#473526"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M365.812 252.35C351.282 254.35 338.602 237.99 338.602 237.99C331.972 240.31 326.832 235.16 328.902 229.99C329.276 229.03 329.91 228.192 330.732 227.57C331.397 227.072 332.166 226.73 332.982 226.57C333.608 226.452 334.249 226.428 334.882 226.5C336.097 226.639 337.256 227.083 338.253 227.791C339.25 228.499 340.051 229.449 340.582 230.55C341.042 231.35 344.132 231.21 342.752 227.69C341.542 224.63 340.222 224.86 340.222 224.86C342.222 224.23 340.632 219.75 338.222 220.39C340.222 219.53 340.922 215.74 338.682 214.39C341.092 214.26 343.732 213.3 342.752 209.63C343.195 210.166 343.784 210.561 344.448 210.769C345.112 210.976 345.822 210.986 346.491 210.797C347.161 210.609 347.761 210.23 348.219 209.707C348.677 209.183 348.973 208.538 349.072 207.85C349.517 208.284 350.078 208.58 350.688 208.701C351.297 208.822 351.929 208.764 352.506 208.533C353.083 208.302 353.581 207.909 353.939 207.401C354.297 206.892 354.499 206.291 354.522 205.67C354.822 207.02 356.402 207.42 357.652 206.67C360.472 209.75 362.984 213.1 365.152 216.67L365.232 216.8C366.452 218.7 367.602 220.62 368.642 222.53C376.532 237 378.602 250.58 365.812 252.35Z",
    fill: "#B25E47"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M348.249 225.05C347.719 226.84 344.469 227.45 340.999 226.42C337.529 225.39 335.129 223.1 335.659 221.31C336.189 219.52 339.439 218.92 342.909 219.95C346.379 220.98 348.779 223.27 348.249 225.05Z",
    fill: "#A0503D"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M368.701 222.6C367.271 223.6 365.861 223.92 364.941 223.28C363.551 222.34 363.751 219.6 365.291 216.87C366.511 218.77 367.661 220.69 368.701 222.6Z",
    fill: "#A0503D"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M334.891 226.56C334.258 226.488 333.618 226.512 332.991 226.63C332.176 226.79 331.407 227.132 330.741 227.63C326.121 214.05 338.301 207.14 338.301 207.14C333.661 213.89 334.381 223 334.891 226.56Z",
    fill: "white"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M358.641 216.53C358.639 216.795 358.715 217.054 358.86 217.275C359.005 217.496 359.213 217.67 359.456 217.773C359.7 217.877 359.969 217.906 360.229 217.857C360.489 217.808 360.728 217.683 360.918 217.498C361.107 217.313 361.237 217.076 361.292 216.817C361.346 216.558 361.323 216.289 361.225 216.043C361.127 215.798 360.959 215.586 360.741 215.436C360.523 215.286 360.265 215.204 360.001 215.2C359.823 215.196 359.647 215.227 359.482 215.292C359.318 215.358 359.167 215.455 359.041 215.579C358.914 215.703 358.813 215.851 358.745 216.014C358.676 216.177 358.641 216.353 358.641 216.53Z",
    fill: "#683F1D"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M349.922 219.36C349.922 219.625 350 219.884 350.148 220.104C350.295 220.325 350.504 220.497 350.749 220.598C350.994 220.699 351.263 220.726 351.523 220.674C351.783 220.623 352.022 220.495 352.209 220.308C352.397 220.12 352.524 219.881 352.576 219.621C352.628 219.361 352.601 219.092 352.5 218.847C352.398 218.602 352.227 218.393 352.006 218.246C351.786 218.099 351.527 218.02 351.262 218.02C351.086 218.02 350.912 218.055 350.749 218.122C350.586 218.189 350.439 218.288 350.314 218.412C350.19 218.537 350.091 218.685 350.024 218.847C349.957 219.01 349.922 219.184 349.922 219.36Z",
    fill: "#683F1D"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M358.843 205.4C358.597 205.934 358.205 206.388 357.713 206.71C356.463 207.5 354.883 207.1 354.583 205.71C354.56 206.331 354.357 206.932 354 207.441C353.642 207.949 353.144 208.342 352.567 208.573C351.99 208.804 351.358 208.862 350.748 208.741C350.139 208.62 349.578 208.324 349.133 207.89C349.034 208.578 348.738 209.223 348.28 209.747C347.822 210.27 347.221 210.649 346.552 210.837C345.883 211.026 345.173 211.016 344.509 210.809C343.845 210.601 343.256 210.206 342.813 209.67C343.813 213.34 341.153 214.3 338.743 214.43C340.983 215.76 340.233 219.55 338.283 220.43C340.643 219.79 342.283 224.27 340.283 224.9C340.283 224.9 341.603 224.67 342.813 227.73C344.193 231.25 341.103 231.39 340.643 230.59C339.981 229.189 338.882 228.041 337.511 227.32C336.14 226.598 334.572 226.342 333.043 226.59C332.383 223.833 332.251 220.976 332.653 218.17C333.277 213.948 335.277 210.05 338.343 207.08C336.183 203.66 340.253 199.19 343.653 201.77C343.213 198.66 348.573 196.69 350.603 200.41C351.773 197.07 356.743 199.11 356.183 201.58C357.803 200.7 360.003 203 358.843 205.4Z",
    fill: "#604730"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M353.871 215.2C357.161 222.25 362.151 218.39 363.411 223.71",
    stroke: "#934735",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M351.09 227C356.79 228.61 360.77 227.56 361.71 227C361.71 227 362.27 232.06 357.17 231.65C355.795 231.618 354.465 231.15 353.373 230.315C352.28 229.479 351.481 228.319 351.09 227Z",
    fill: "white",
    stroke: "#934735",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M331.891 232.79C332.601 229.2 338.201 229.24 339.241 234.38",
    stroke: "#934735",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M336.401 236.12C333.271 235.31 334.751 230.57 338.171 231.93",
    stroke: "#934735",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M345.242 216.18C344.992 217.85 351.242 214.24 349.952 212.18C348.662 210.12 345.472 214.56 345.242 216.18Z",
    fill: "#604730"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M361.15 210.05C362.45 211.13 355.38 212.64 355 210.27C354.62 207.9 359.89 209 361.15 210.05Z",
    fill: "#604730"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M300.181 355.13C295.092 354.118 289.951 353.384 284.781 352.93",
    stroke: "#934735",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M284.781 352.93C266.421 351.31 252.921 366.65 261.111 378.41C271.471 393.28 337.791 389.48 344.601 389.31C348.921 389.21 348.601 392.39 355.211 393.01C359.211 393.4 365.331 393.42 366.621 392.77C367.591 392.119 368.373 391.226 368.891 390.18C368.891 390.18 372.671 391.69 374.181 387.37C374.181 387.37 378.031 388.24 378.661 382.83C378.661 382.83 380.991 385.73 383.141 384.67C385.601 383.46 385.951 381.67 384.221 379.38C382.491 377.09 375.371 369 373.001 368.15C370.631 367.3 352.831 370.45 349.791 369.77C334.521 366.36 313.621 355.47 284.781 352.93Z",
    fill: "#B25E47"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M362.473 393.27C363.874 393.321 365.274 393.153 366.623 392.77C367.592 392.119 368.375 391.226 368.893 390.18C368.893 390.18 372.673 391.69 374.183 387.37C374.183 387.37 378.033 388.24 378.663 382.83C378.663 382.83 380.993 385.73 383.143 384.67C385.603 383.46 385.953 381.67 384.223 379.38C382.493 377.09 375.373 369 373.003 368.15",
    stroke: "#934735",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M379.15 383.37L373.73 377.43",
    stroke: "#934735",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M374.18 387.37L368.5 383.77",
    stroke: "#934735",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M368.892 390.18L365.012 388.99",
    stroke: "#934735",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M268.091 178.4L264.011 178.82L259.191 179.34L262.461 175.92L265.481 172.77L268.091 178.4Z",
    fill: "white"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M252.142 300.14C264.802 308.14 276.332 299.3 279.512 283.2C284.202 259.43 288.232 199.38 288.232 199.38C288.232 199.38 294.662 185.46 296.712 180.43C298.762 175.4 298.432 170.93 295.452 169.64C295.452 169.64 292.452 160.34 287.832 160.05C286.944 159.576 286.017 159.178 285.062 158.86C282.752 158.39 278.502 160.52 277.382 161.7C276.262 162.88 279.982 164.12 282.102 163.77C284.222 163.42 285.772 168.77 284.822 171.03C283.872 173.29 279.822 177.83 278.382 176.65C276.942 175.47 276.492 171.39 277.082 168.2C277.672 165.01 277.262 163.41 275.132 164.65C273.002 165.89 268.872 176.23 269.342 178.12C269.812 180.01 272.532 187.81 272.712 189.12C272.892 190.43 252.112 258.82 248.012 270.69C243.912 282.56 243.192 294.49 252.142 300.14Z",
    fill: "#FEBD9D"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M295.453 169.64C295.696 171.233 295.836 172.839 295.873 174.45",
    stroke: "#EF8A66",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M290 167C290.599 169.199 290.935 171.462 291 173.74",
    stroke: "#EF8A66",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M265.48 172.77L272.27 168.91C270.71 172.11 269.27 176.18 269.27 177.76L268.06 178.4C267.52 178.201 267.025 177.897 266.603 177.506C266.181 177.115 265.84 176.644 265.6 176.121C265.361 175.598 265.227 175.033 265.206 174.457C265.185 173.882 265.278 173.309 265.48 172.77Z",
    fill: "#683F1D"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M264.011 178.82L259.191 179.34L262.461 175.92L264.011 178.82Z",
    fill: "#683F1D"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M269.342 178.13C268.872 176.24 273.012 165.89 275.132 164.66C276.702 163.74 277.342 164.36 277.332 166.04C277.314 166.766 277.23 167.489 277.082 168.2C276.884 169.315 276.797 170.448 276.822 171.58C276.822 171.73 276.822 171.88 276.822 172.02V172.45C276.822 172.66 276.822 172.87 276.892 173.07L276.982 173.67C277.076 174.795 277.552 175.854 278.332 176.67C279.812 177.86 283.832 173.36 284.772 171.07C284.969 170.549 285.067 169.997 285.062 169.44",
    stroke: "#EF8A66",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M281.203 163.83C279.083 163.83 276.403 162.73 277.373 161.7C278.503 160.52 282.753 158.39 285.063 158.86C286.017 159.175 286.944 159.57 287.833 160.04",
    stroke: "#EF8A66",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M293.41 165C294.203 166.482 294.872 168.028 295.41 169.62C297.35 170.46 298.17 172.62 297.93 175.47",
    stroke: "#EF8A66",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M297.71 162.76L293.41 165.02L285.11 169.41L277 173.67C276.703 171.857 276.72 170.007 277.05 168.2C277.199 167.489 277.282 166.766 277.3 166.04L281.17 163.83L287.83 160.04L294.36 156.34L297.71 162.76Z",
    fill: "#683F1D"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M293.151 156.34C292.781 158.03 293.981 162.97 297.091 163.96L299.091 162.72L295.241 155.21L293.151 156.34Z",
    fill: "white"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M298.74 158C299.9 160.12 300.15 162.2 299.31 162.66C298.47 163.12 296.85 161.78 295.7 159.66C294.55 157.54 294.29 155.46 295.13 155C295.97 154.54 297.58 155.88 298.74 158Z",
    fill: "#683F1D"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M269.342 178.13C268.872 176.24 273.012 165.89 275.132 164.66C276.702 163.74 277.342 164.36 277.332 166.04C277.314 166.766 277.23 167.489 277.082 168.2C276.884 169.315 276.797 170.448 276.822 171.58C276.822 171.73 276.822 171.88 276.822 172.02V172.45C276.822 172.66 276.822 172.87 276.892 173.07L276.982 173.67C277.076 174.795 277.552 175.854 278.332 176.67C279.812 177.86 283.832 173.36 284.772 171.07C284.969 170.549 285.067 169.997 285.062 169.44",
    stroke: "#EF8A66",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M156.421 281.63C153.491 294.63 133.221 290.47 132.081 283.81C130.941 277.15 132.781 275.5 134.341 263.3C135.621 253.3 152.601 253.11 155.611 259.82C156.096 260.903 156.208 262.116 155.931 263.27C155.299 266.676 155.282 270.168 155.881 273.58C156.311 276.78 156.891 279.5 156.421 281.63Z",
    fill: "#FEBD9D"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M155.931 263.27C155.299 266.676 155.282 270.168 155.881 273.58C147.221 271.08 145.711 261.36 145.711 261.36L155.611 259.82C156.096 260.903 156.208 262.116 155.931 263.27Z",
    fill: "#F4A789"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M104.4 373.65L123.9 381.13C123.9 381.13 121.19 403.67 120.98 403.34C120.77 403.01 88.1602 399.61 88.1602 399.61L104.4 373.65Z",
    fill: "#FEBD9D"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M76 386.77C78.72 396.6 85.54 400.18 92.07 399.96C98.6 399.74 107.64 396.31 111 386C113.57 378.11 108 368.65 108 368.65L76 386.77Z",
    fill: "white"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M113.118 503.08C113.118 503.08 115.618 489.44 110.328 466.87C108.067 458.055 107.057 448.966 107.328 439.87C107.938 425.95 112.248 410.4 122.858 389.25L190.858 386.46C193.898 395.92 196.658 404.613 199.138 412.54C206.668 436.54 211.798 453.84 215.388 465.54C220.168 481.1 228.248 503.09 228.248 503.09L113.118 503.08Z",
    fill: "#FED81D"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M199.181 412.55C192.011 433.39 181.811 442.83 155.431 433.12C131.711 424.4 123.011 418.12 107.371 439.88C107.981 425.96 112.291 410.41 122.901 389.26L190.901 386.47C193.941 395.93 196.701 404.623 199.181 412.55Z",
    fill: "#FFE05C"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M192.85 351.29C189.1 365.84 192.57 381.64 194.09 385.1C195.61 388.56 194.37 390.93 192.16 391.34C189.95 391.75 124.8 393.7 121.88 393.28C118.96 392.86 118.01 390.65 118.01 388.16C118.01 385.67 112.88 368.16 110.38 361.16C110.38 361.16 110.11 380.7 104.7 386.52C99.2903 392.34 86.7003 394.7 78.7903 390.41C77.3152 389.476 76.2664 388 75.8703 386.3C72.8703 376.96 77.5103 355.63 80.7303 340.38C82.0103 334.26 83.8603 326.61 86.2203 318.97C90.9703 303.58 97.8003 288.2 106.22 285.45C125 279.32 138.67 281.71 148.63 280.78C151.73 280.48 154.73 280.12 157.63 279.78H157.74C173.53 277.78 185.62 275.95 191.62 286.1C192.549 287.71 193.281 289.426 193.8 291.21C197.51 303.45 195.97 311.52 195.16 322.82C195.16 323.27 195.11 323.72 195.08 324.18C195.853 333.278 195.099 342.441 192.85 351.29Z",
    fill: "#C3DCF8"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M110.381 361.12C110.381 361.12 110.111 380.66 104.701 386.48C99.2911 392.3 86.7011 394.66 78.7911 390.37C77.316 389.436 76.2672 387.96 75.8711 386.26C101.341 393.83 109.821 366.73 103.031 361.73C96.4211 356.86 96.5211 343.8 100.561 337.01C103.251 344.8 108.311 354.72 110.381 361.12Z",
    fill: "#A7CAF0"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M191.609 286C184.399 291.5 178.359 298.54 175.929 307.67C174.289 313.81 171.629 318.6 168.039 322C158.309 331.26 141.729 330.28 120.279 318.21C105.429 309.87 95.2788 311.64 86.2188 318.9C90.9688 303.51 97.7987 288.13 106.219 285.38C124.999 279.25 138.669 281.64 148.629 280.71C151.729 280.41 154.729 280.05 157.629 279.71H157.739C173.519 277.75 185.609 275.89 191.609 286Z",
    fill: "#D0E5F7"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8398 330.07C99.1346 332.447 99.712 334.78 100.56 337.02C103.25 344.8 108.31 354.72 110.38 361.12",
    stroke: "#83ADDF",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M263.539 303.7C259.409 306.45 236.059 312.97 217.669 318.25C210.306 320.396 202.771 321.905 195.149 322.76C188.424 323.539 181.639 323.663 174.889 323.13C172.566 322.936 170.262 322.559 167.999 322C139.309 315.06 143.879 282.19 157.579 279.69H157.689C177.236 276.246 196.95 273.826 216.749 272.44C225.329 271.91 234.089 271.67 242.539 271.89C275.399 272.78 267.669 301 263.539 303.7Z",
    fill: "#C3DCF8"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M263.541 303.7C259.411 306.45 236.061 312.97 217.671 318.25C210.307 320.396 202.773 321.905 195.151 322.76C188.425 323.539 181.64 323.663 174.891 323.13",
    stroke: "#83ADDF",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M216.788 272.47C209.238 275.6 199.688 279.86 191.608 286.04C184.398 291.54 178.358 298.58 175.928 307.71C174.288 313.85 171.628 318.64 168.038 322.04C139.348 315.1 143.918 282.23 157.618 279.73H157.728C177.275 276.282 196.989 273.859 216.788 272.47Z",
    fill: "#D0E5F7"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M239.5 271.85C244.56 269.91 250.07 270.3 257.11 273.66C265.35 277.6 272.49 287.73 269.01 301.66C268.44 303.91 259.68 308.59 258.23 307.56C256.78 306.53 268.26 278 239.5 271.85Z",
    fill: "white"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M136.998 264.44C154.368 268.55 163.138 266.78 165.378 257.63C167.618 248.48 158.288 234.57 158.288 234.57L159.028 229.57C156.956 228.615 154.934 227.557 152.968 226.4C152.028 225.65 148.968 217.9 146.148 217.15C143.328 216.4 123.558 226.58 129.438 243.38C135.318 260.18 136.998 264.44 136.998 264.44Z",
    fill: "#FEBD9D"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M153.857 239.34C153.257 241.24 150.127 241.96 146.857 240.94C143.587 239.92 141.437 237.54 142.027 235.63C142.617 233.72 145.757 233 149.027 234.03C152.297 235.06 154.457 237.43 153.857 239.34Z",
    fill: "#F4AF90"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M158.257 234.57L158.997 229.57C156.926 228.615 154.903 227.557 152.938 226.4",
    stroke: "#EF8A66",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M144.049 299.58C135.879 301.58 133.859 293.31 133.859 293.31C127.269 300.14 119.479 298.18 117.679 294.57C117.679 294.57 110.969 297.34 105.599 293.31C98.2187 287.78 103.029 279.55 103.029 279.55C95.2887 277.55 96.7087 269.82 101.149 266.55L101.809 266.09C106.429 263.09 114.729 261.09 111.679 255.09C108.499 248.7 105.889 239.9 114.099 234.98C114.099 234.98 114.519 225.49 120.419 222.38C126.319 219.27 126.709 218.04 126.839 216.28C127.289 209.8 133.409 203.68 140.349 208.45C140.569 208.6 140.799 208.76 141.019 208.93C148.449 208.19 150.409 215.18 149.159 218.55C151.819 227.27 145.479 233.81 147.279 236.86C149.339 240.34 147.769 244.5 147.769 244.5C144.699 239.63 140.919 238.09 138.319 242.26C136.209 245.66 137.929 250.11 144.759 254.35C152.069 258.89 148.609 264.72 147.009 269.11C146.075 271.68 145.761 274.434 146.093 277.149C146.425 279.863 147.393 282.461 148.919 284.73C152.449 289.76 152.219 297.62 144.049 299.58Z",
    fill: "#7F542D"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M144.049 299.58C135.879 301.58 133.859 293.31 133.859 293.31C127.269 300.14 119.479 298.18 117.679 294.57C117.679 294.57 110.969 297.34 105.599 293.31C98.2187 287.78 103.029 279.55 103.029 279.55C95.2887 277.55 96.7087 269.82 101.149 266.55L101.809 266.09C104.919 274.82 110.579 279.54 116.349 278.18C124.019 276.4 128.349 272.18 135.529 276.6C142.709 281.02 144.859 260.4 134.339 257.29C123.819 254.18 121.799 236.49 130.899 234.29C137.709 232.69 143.829 218.92 140.349 208.36C140.569 208.51 140.799 208.67 141.019 208.84C148.449 208.1 150.409 215.09 149.159 218.46C151.819 227.18 145.479 233.72 147.279 236.77C149.339 240.25 147.769 244.41 147.769 244.41C144.699 239.54 140.919 238 138.319 242.17C136.209 245.57 137.929 250.02 144.759 254.26C152.069 258.8 148.609 264.63 147.009 269.02C146.075 271.59 145.761 274.344 146.093 277.059C146.425 279.773 147.393 282.371 148.919 284.64C152.449 289.76 152.219 297.62 144.049 299.58Z",
    fill: "#704725"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M150.688 231.27C150.688 231.533 150.766 231.79 150.912 232.009C151.058 232.228 151.266 232.398 151.509 232.499C151.752 232.599 152.019 232.626 152.277 232.574C152.535 232.523 152.772 232.396 152.958 232.21C153.144 232.024 153.271 231.787 153.322 231.529C153.373 231.271 153.347 231.004 153.246 230.761C153.146 230.518 152.975 230.31 152.756 230.164C152.538 230.018 152.281 229.94 152.018 229.94C151.843 229.939 151.669 229.972 151.507 230.039C151.345 230.105 151.198 230.203 151.074 230.327C150.95 230.45 150.852 230.597 150.786 230.759C150.72 230.921 150.686 231.095 150.688 231.27Z",
    fill: "#683F1D"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M103 279.56C106.79 272.05 110.24 272.27 113.46 269.79C116.68 267.31 118.09 262.15 117.46 259.79",
    stroke: "#A56F42",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M117.677 294.57C116.654 292.909 116.198 290.96 116.378 289.018C116.559 287.076 117.365 285.244 118.677 283.8",
    stroke: "#A56F42",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M133.859 293.31C133.37 292.04 133.153 290.681 133.224 289.321C133.295 287.962 133.651 286.633 134.269 285.42",
    stroke: "#A56F42",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M127.668 222.84C132.108 221.84 132.538 218.67 133.868 216.06C135.198 213.45 137.258 209.41 141.018 208.86",
    stroke: "#A56F42",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M149.159 218.48C147.809 215.48 143.529 211.89 139.559 215.48",
    stroke: "#A56F42",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M141.447 247.82C141.357 244.06 145.067 243.18 147.947 246.05",
    stroke: "#EF8A66",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M146.44 249.45C143.54 249.45 143.44 245.1 147.13 245.35",
    stroke: "#EF8A66",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M155.43 240.19C155.964 240.868 156.681 241.379 157.495 241.665C158.31 241.95 159.189 241.997 160.03 241.8",
    stroke: "#EF8A66",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M141 251.45C143.2 253.22 147.17 252.97 147.17 252.97",
    stroke: "#EF8A66",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M149.539 255.09C151.096 255.09 152.359 253.827 152.359 252.27C152.359 250.713 151.096 249.45 149.539 249.45C147.981 249.45 146.719 250.713 146.719 252.27C146.719 253.827 147.981 255.09 149.539 255.09Z",
    fill: "white"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M147.4 230C148.78 230.9 152.1 224.52 149.5 222.77C146.9 221.02 145.54 228.79 147.4 230Z",
    fill: "#7F542D"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M707.412 498.01H87.2416C81.7795 498.01 77.3516 502.438 77.3516 507.9V509.45C77.3516 514.912 81.7795 519.34 87.2416 519.34H707.412C712.874 519.34 717.302 514.912 717.302 509.45V507.9C717.302 502.438 712.874 498.01 707.412 498.01Z",
    fill: "#EDEDED"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5312 519.34C112.931 511.5 137.261 509.77 155.801 519.34",
    stroke: "#DDDDDD",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8711 498C107.041 507 117.791 506.27 137.741 506C152.601 505.81 170.491 513.38 182.401 519.33",
    stroke: "#DDDDDD",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M167.621 498C179.351 511.19 187.491 512.84 191.431 509.44C195.611 505.83 199.911 504.85 204.351 508.66C209.491 513.08 216.641 504.13 220.661 498",
    stroke: "#DDDDDD",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M213.363 519.34C218.103 514.97 226.553 509.57 239.713 508.67C255.313 507.67 275.133 514.85 285.713 519.34",
    stroke: "#DDDDDD",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M265.23 498C283.53 507.6 303.53 513.22 319.69 508.66C335.46 504.23 373.12 509.75 386.82 498",
    stroke: "#DDDDDD",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M334.641 519.34C346.361 512.67 364.641 508.59 378.861 519.34",
    stroke: "#DDDDDD",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M399 519.34C420.79 502.4 464.29 499.34 500.62 508.58C543.62 519.53 562.9 506.89 570.71 498.01",
    stroke: "#DDDDDD",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M438.18 519.34C453.96 512.25 475.18 510.79 497.59 519.34",
    stroke: "#DDDDDD",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M575.73 519.34C602.15 507.04 623.291 508.47 642.891 519.34",
    stroke: "#DDDDDD",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M613 498C656.53 512.62 692.55 523.94 716.28 504.1",
    stroke: "#DDDDDD",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M647.723 498C669.813 511 695.613 510 711.493 499.17",
    stroke: "#DDDDDD",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationTeam);
export default __webpack_public_path__ + "static/media/IllustrationTeam.cc78ca2157b112170e79960ed5d59ac6.svg";
export { ForwardRef as ReactComponent };